// import React, { useEffect, useState } from "react";
// import { Box } from "@mui/material";

// function Contacts({ contacts, service, displayAmount = 30, setSelectedContact, displaySendAgain, onDeleteContact }) {

//     const [filteredContacts, setFilteredContacts] = useState(null);

//     const decodeHtml = (str) => {
//         if (!str) return "";

//         return str
//             .replace(/&amp;/g, "&")
//             .replace(/&lt;/g, "<")
//             .replace(/&gt;/g, ">")
//             .replace(/&quot;/g, '"')
//             .replace(/&#039;/g, "'")
//             .replace(/&nbsp;/g, " ")
//             .replace(/&aacute;/g, "á")
//             .replace(/&eacute;/g, "é")
//             .replace(/&iacute;/g, "í")
//             .replace(/&oacute;/g, "ó")
//             .replace(/&uacute;/g, "ú")
//             .replace(/&Aacute;/g, "Á")
//             .replace(/&Eacute;/g, "É")
//             .replace(/&Iacute;/g, "Í")
//             .replace(/&Oacute;/g, "Ó")
//             .replace(/&Uacute;/g, "Ú")
//             .replace(/&ntilde;/g, "ñ")
//             .replace(/&Ntilde;/g, "Ñ")
//             .replace(/&uuml;/g, "ü")
//             .replace(/&Uuml;/g, "Ü")
//             .replace(/&ouml;/g, "ö")
//             .replace(/&Ouml;/g, "Ö")
//             .replace(/&szlig;/g, "ß")
//             .replace(/&euro;/g, "€")
//             .replace(/&copy;/g, "©")
//             .replace(/&reg;/g, "®");
//     };

//     useEffect(() => {
//         if (!contacts) return;

//         const filtered = contacts.filter((contact) => {
//             try {
//                 const otherdata = JSON.parse(
//                     contact?.Usercontactlistexternal?.other?.replaceAll(/&(amp;)*quot;/g, '"')
//                 );
//                 return otherdata?.type === service;
//             } catch (error) {
//                 console.error("Error parsing 'other' JSON:", error);
//                 return false;
//             }
//         });

//         setFilteredContacts(filtered);
//     }, [contacts, service]);

//     const handleDelete = (row, e) => {
//         e.stopPropagation();
//         if (!onDeleteContact) return;
//         if (!window.confirm("Remove this contact?")) return;
//         onDeleteContact(row);
//     };

//     return (
//         <Box
//             sx={{
//                 maxHeight: '225px',
//                 overflowY: 'auto',
//                 paddingRight: 1,
//             }}
//         >
//             <style>{`
//                 .contact-delete-btn {
//                     position: absolute;
//                     top: 6px;
//                     right: 6px;
//                     width: 22px;
//                     height: 22px;
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     border: none;
//                     background: transparent;
//                     border-radius: 50%;
//                     cursor: pointer;
//                     color: #adb5bd;
//                     padding: 0;
//                     transition: background-color 0.15s ease, color 0.15s ease;
//                 }
//                 .contact-delete-btn:hover {
//                     background-color: #fdecea;
//                     color: #dc3545;
//                 }
//             `}</style>
//             <Box className="d-flex justify-content-start flex-wrap gap-3 mt-4">
//                 {filteredContacts?.slice(0, displayAmount).map((row, index) => {
//                     const data = row.Usercontactlistexternal;
//                     let otherdata = {};
//                     try {
//                         otherdata = JSON.parse(data.other.replaceAll(/&(amp;)*quot;/g, '"'));
//                     } catch (error) {

//                     }

//                     let name = ["EMER", "RIA", "BPI"].includes(otherdata?.type)
//                         ? `${data.firstName} ${data.lastName}`
//                         : data.lastName;

//                     if (service === "MoneyGram") {
//                         name = decodeHtml(name);
//                     }

//                     return (
//                         <Box
//                             className="border rounded p-3 light-grey-border"
//                             key={data.id}
//                             sx={{ position: 'relative' }}
//                         >
//                             {onDeleteContact && (
//                                 <button
//                                     type="button"
//                                     className="contact-delete-btn"
//                                     onClick={(e) => handleDelete(row, e)}
//                                     aria-label="Delete contact"
//                                     title="Delete contact"
//                                 >
//                                     <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
//                                         <path
//                                             d="M2 4h12M5.5 4V2.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1V4M6.5 7.5v4M9.5 7.5v4M3.5 4l.6 8.4a1 1 0 0 0 1 .9h5.8a1 1 0 0 0 1-.9L13.5 4"
//                                             stroke="currentColor"
//                                             strokeWidth="1.3"
//                                             strokeLinecap="round"
//                                             strokeLinejoin="round"
//                                         />
//                                     </svg>
//                                 </button>
//                             )}
//                             <Box className="text-black fs-size-14 fw-bold" sx={{ pr: onDeleteContact ? 3 : 0 }}>{name}</Box>
//                             <Box className="text-muted fs-size-10">{otherdata?.ctry ?? otherdata?.receivercountrycode ?? ''}</Box>
//                             {displaySendAgain !== false && <button
//                                 className="border w-100 border-dark bg-white mt-2 border-50-round border-2 fs-size-12 fw-bold"
//                                 onClick={() => setSelectedContact(row)}
//                             >
//                                 Send Again
//                             </button>}
//                         </Box>);
//                 })}
//             </Box>
//         </Box>
//     );
// }

// export default Contacts;

import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";

function Contacts({ contacts, service, displayAmount = 30, setSelectedContact, displaySendAgain, onDeleteContact }) {

    const [filteredContacts, setFilteredContacts] = useState(null);
    const [confirmingId, setConfirmingId] = useState(null);
    const [deletingId, setDeletingId] = useState(null);

    const decodeHtml = (str) => {
        if (!str) return "";

        return str
            .replace(/&amp;/g, "&")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&quot;/g, '"')
            .replace(/&#039;/g, "'")
            .replace(/&nbsp;/g, " ")
            .replace(/&aacute;/g, "á")
            .replace(/&eacute;/g, "é")
            .replace(/&iacute;/g, "í")
            .replace(/&oacute;/g, "ó")
            .replace(/&uacute;/g, "ú")
            .replace(/&Aacute;/g, "Á")
            .replace(/&Eacute;/g, "É")
            .replace(/&Iacute;/g, "Í")
            .replace(/&Oacute;/g, "Ó")
            .replace(/&Uacute;/g, "Ú")
            .replace(/&ntilde;/g, "ñ")
            .replace(/&Ntilde;/g, "Ñ")
            .replace(/&uuml;/g, "ü")
            .replace(/&Uuml;/g, "Ü")
            .replace(/&ouml;/g, "ö")
            .replace(/&Ouml;/g, "Ö")
            .replace(/&szlig;/g, "ß")
            .replace(/&euro;/g, "€")
            .replace(/&copy;/g, "©")
            .replace(/&reg;/g, "®");
    };

    useEffect(() => {
        if (!contacts) return;

        const filtered = contacts.filter((contact) => {
            try {
                const otherdata = JSON.parse(
                    contact?.Usercontactlistexternal?.other?.replaceAll(/&(amp;)*quot;/g, '"')
                );
                return otherdata?.type === service;
            } catch (error) {
                console.error("Error parsing 'other' JSON:", error);
                return false;
            }
        });

        setFilteredContacts(filtered);
    }, [contacts, service]);

    const handleDeleteClick = (id, e) => {
        e.stopPropagation();
        setConfirmingId(id);
    };

    const handleCancelDelete = (e) => {
        e.stopPropagation();
        setConfirmingId(null);
    };

    const handleConfirmDelete = async (row, e) => {
        e.stopPropagation();
        if (!onDeleteContact) return;
        setDeletingId(row.Usercontactlistexternal.id);
        try {
            await onDeleteContact(row);
        } finally {
            setDeletingId(null);
            setConfirmingId(null);
        }
    };

    return (
        <Box
            sx={{
                maxHeight: '225px',
                overflowY: 'auto',
                paddingRight: 1,
            }}
        >
            <style>{`
                .contact-delete-btn {
                    position: absolute;
                    top: 6px;
                    right: 6px;
                    width: 22px;
                    height: 22px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: none;
                    background: transparent;
                    border-radius: 50%;
                    cursor: pointer;
                    color: #adb5bd;
                    padding: 0;
                    transition: background-color 0.15s ease, color 0.15s ease;
                }
                .contact-delete-btn:hover {
                    background-color: #fdecea;
                    color: #dc3545;
                }
                .contact-confirm-overlay {
                    position: absolute;
                    inset: 0;
                    background: #ffffff;
                    border-radius: inherit;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    padding: 8px;
                    z-index: 2;
                    animation: contact-confirm-fade 0.12s ease-out;
                }
                @keyframes contact-confirm-fade {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                .contact-confirm-text {
                    font-size: 12px;
                    font-weight: 600;
                    color: #3A3A3A;
                    text-align: center;
                }
                .contact-confirm-actions {
                    display: flex;
                    gap: 6px;
                    width: 100%;
                }
                .contact-confirm-btn {
                    flex: 1;
                    border: none;
                    border-radius: 50px;
                    padding: 4px 0;
                    font-size: 11px;
                    font-weight: 700;
                    cursor: pointer;
                }
                .contact-confirm-btn.cancel {
                    background: #f1f3f5;
                    color: #495057;
                }
                .contact-confirm-btn.cancel:hover {
                    background: #e9ecef;
                }
                .contact-confirm-btn.delete {
                    background: #dc3545;
                    color: #fff;
                }
                .contact-confirm-btn.delete:hover {
                    background: #c82333;
                }
                .contact-confirm-btn:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }
            `}</style>
            <Box className="d-flex justify-content-start flex-wrap gap-3 mt-4">
                {filteredContacts?.slice(0, displayAmount).map((row, index) => {
                    const data = row.Usercontactlistexternal;
                    let otherdata = {};
                    try {
                        otherdata = JSON.parse(data.other.replaceAll(/&(amp;)*quot;/g, '"'));
                    } catch (error) {

                    }

                    let name = ["EMER", "RIA", "BPI"].includes(otherdata?.type)
                        ? `${data.firstName} ${data.lastName}`
                        : data.lastName;

                    if (service === "MoneyGram") {
                        name = decodeHtml(name);
                    }

                    const isConfirming = confirmingId === data.id;
                    const isDeleting = deletingId === data.id;

                    return (
                        <Box
                            className="border rounded p-3 light-grey-border"
                            key={data.id}
                            sx={{ position: 'relative' }}
                        >
                            {onDeleteContact && (
                                <button
                                    type="button"
                                    className="contact-delete-btn"
                                    onClick={(e) => handleDeleteClick(data.id, e)}
                                    aria-label="Delete contact"
                                    title="Delete contact"
                                >
                                    <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M2 4h12M5.5 4V2.5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1V4M6.5 7.5v4M9.5 7.5v4M3.5 4l.6 8.4a1 1 0 0 0 1 .9h5.8a1 1 0 0 0 1-.9L13.5 4"
                                            stroke="currentColor"
                                            strokeWidth="1.3"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </button>
                            )}
                            <Box className="text-black fs-size-14 fw-bold" sx={{ pr: onDeleteContact ? 3 : 0 }}>{name}</Box>
                            <Box className="text-muted fs-size-10">{otherdata?.ctry ?? otherdata?.receivercountrycode ?? ''}</Box>
                            {displaySendAgain !== false && <button
                                className="border w-100 border-dark bg-white mt-2 border-50-round border-2 fs-size-12 fw-bold"
                                onClick={() => setSelectedContact(row)}
                            >
                                Send Again
                            </button>}

                            {isConfirming && (
                                <Box className="contact-confirm-overlay" onClick={(e) => e.stopPropagation()}>
                                    <Box className="contact-confirm-text">Remove {name}?</Box>
                                    <Box className="contact-confirm-actions">
                                        <button
                                            type="button"
                                            className="contact-confirm-btn cancel"
                                            onClick={handleCancelDelete}
                                            disabled={isDeleting}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            className="contact-confirm-btn delete"
                                            onClick={(e) => handleConfirmDelete(row, e)}
                                            disabled={isDeleting}
                                        >
                                            {isDeleting ? "..." : "Delete"}
                                        </button>
                                    </Box>
                                </Box>
                            )}
                        </Box>);
                })}
            </Box>
        </Box>
    );
}

export default Contacts;